// extracted by mini-css-extract-plugin
export var phone = "_15-0";
export var phoneDragging = "_15-1";